import { create } from "zustand";

interface ModalState {
  isBusinessHoursModalOpen: boolean;
  openBusinessHoursModal: () => void;
  closeBusinessHoursModal: () => void;
}

export const useBusinessHoursModalStore = create<ModalState>((set) => ({
  isBusinessHoursModalOpen: false,
  openBusinessHoursModal: () => set({ isBusinessHoursModalOpen: true }),
  closeBusinessHoursModal: () => set({ isBusinessHoursModalOpen: false }),
}));
